import 'select2';
import 'select2/dist/css/select2';
import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    $('#attendances-actions-in-batch-frame-modal .select2').select2({
      placeholder: '-- selecione --',
      multiple: true,
      allowClear: true,
      escapeMarkup: (markup) => markup,
      dropdownParent: this.element.closest('.modal')
    }).val([' ']).trigger("change");
  }
}
